import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';

import {push as changeURL} from 'react-router-redux';
import * as urls from '~/routing/urls';
import mapDispatch from '~/misc/mapDispatch';
import StatusSelect from './StatusSelect';
import ListTable from './ListTable';
import Spinner from '~/components/common/Spinner';
import css from './index.css';

import checkBoxCss from './ListTable/index.css'
import {
  changeStatus,
  removeAlert,
  getAlertLists,
  clearMathesNum,
  changeEquipment,
  changeSelectedAll,
} from "~/modules/alert/actions";
// import sharedCSS from '../../shared.css';
import * as equipment from '~/misc/equipment';

const StatusButton = (props) => (
  <div className={cs(css.btnCan, css[props.wrapClass], { [css.btnDisabled]: props.disabled, [css.btnHover]: !props.disabled})} onClick={(ev)=>{ if(props.disabled) return; props.fn(ev)}}>
    <div className={cs(css.btnIcon, css['btnIcon-'+ props.iconType])}></div>
    <span>{props.title}</span>
  </div>
);

const SelectCourt = ({court , selectAll, selected}) => {
  return (
    <div className={css.selectCourt}>
      <div className={cs(checkBoxCss.checkBoxWarp, css.checkBoxWarp)} onClick={selectAll}>
        <div className={cs(checkBoxCss.checkbox, {[checkBoxCss.selected]: selected})}/>
      </div>
      <span className={css.checkBoxNum}>{court}</span> Selected
    </div>
  )
}
  
const getHuman = (id) => 
  id !== 'AL' ?  equipment.idToHuman[id].toLocaleLowerCase() : 'all';


class AlertList extends React.Component {
  constructor(props) {
    super(props);
    this.handleDropChange = this.handleDropChange.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
    this.editItem = this.editItem.bind(this);
    this.changeItem = this.changeItem.bind(this);
    this.clearMathes = this.clearMathes.bind(this);
    this.state = {
      dropValue: 'AL'
    };
  }

  render() {
    const { loading } = this.props;
    return (
      <div className={cs(css.listContainer)}>
        <span className={cs(css.title)}>Alerts</span>
        <div className={cs(css.list)}>
          <div className={cs(css.listHeader)}>
            <StatusSelect dropDownId='statusSelect' initialValue={this.state.dropValue} onChange={this.handleDropChange}/>
            <button
              className={cs(css.addBtn)}
              onClick={this.props.goToAddAlert}
              // disabled={this.props.list.length >= 5}
            >+ Add a load alert</button>
          </div>
          {true && (
            <div className={cs(css.btnBox)}>
              <SelectCourt
                selected= {this.props.isSelectedAll}
                selectAll= {this.props.selectAll}
                court={this._checkedLength()}
              />
              <StatusButton title={'Edit'} iconType={'edit'} wrapClass={'edit'} fn={this.editItem} disabled={!(this._checkedLength() === 1)}/>
              <StatusButton title={'Change Status'} iconType={'change'} wrapClass={'change'} fn={()=>this.changeItem('change status')} disabled={!this._checkedLength() > 0}/>
              <StatusButton title={'Delete'} iconType={'delete'} wrapClass={'del'} fn={this.deleteItem} disabled={!this._checkedLength() > 0}/>
              <StatusButton title={'Clear'} iconType={'clear'} wrapClass={'del'} fn={this.clearMathes} disabled={!this._checkedLength() > 0}/>
            </div>
          )}
          {
            loading
            ? (
              <div className={css.spinnerLine}>
                <div className={css.spinner}>
                  <Spinner scalable={true}/>
                </div>
              </div>
              )
            : <ListTable equipment={this.state.dropValue}/>
          }

          
        </div>
      </div>
    );
  }
  _checkedLength() {
    if(!this.props.list) return 0;
    let array = this.props.list.filter((item) => item.selected === true);
    return array.length;
  }

  handleDropChange(value) {
    this.props.changeEquipment({
      equipment: getHuman(value),
      pushAvailable: this.props.pushAvailable
    });
    // handle value
    this.setState({
      dropValue: value,
    });
  }

  changeItem(type) {
    //const type = e.currentTarget.last.textContent.toLocaleLowerCase();
    const idList = [];
    this.props.list.forEach(item => {
      if(item.selected === true){
        idList.push(item.id);
      }
    });
    if(idList.length){
      this.props.changeStatus({idList, type});
    }
  }
  clearMathes(){
    const idList = []; 
    this.props.list.forEach(item => {
      if(item.selected === true){
        idList.push(item.id);
      }
    });
    if(idList.length){
      this.props.clearMathesNum({id: idList , equipment:{
        equipment : getHuman(this.state.dropValue)
      }});
    }
  }

  deleteItem() {
    const idList = [];
    this.props.list.forEach(item => {
      if (item.selected === true) {
        idList.push(item.id);
      }
    });
    if (idList.length) {
      this.props.removeAlert(idList);
    }
  }

  editItem() {
    const idList = this.props.list.filter(item => item.selected === true);
    if(idList.length){
      this.props.goToEditAlert(idList[0].id);
    }
  }

}

export default connect(({alert}) => ({
  alertList: alert.alertList,
  list: alert.list,
  equipment: alert.equipment,
  pushAvailable: alert.pushAvailable,
  isSelectedAll: alert.isSelectAll,
  loading: alert.loading
}), mapDispatch({
  removeAlert: (props, args) => removeAlert(args),
  goToEditAlert: (props, id) => changeURL(`${urls.ALERT}/${urls.ALERTURL.UpdateAlert}/${id}`),
  goToAddAlert: () => changeURL(`${urls.ALERT}/${urls.ALERTURL.AddAlert}`),
  changeStatus: (props, args) =>  changeStatus(args),
  clearMathesNum: (props, args) => clearMathesNum(args.id, args.equipment),
  getAlertLists: (props, args) => getAlertLists(args),
  changeEquipment: (props, args) => changeEquipment(args),
  selectAll: (props, args) => changeSelectedAll()
}))(AlertList);



// WEBPACK FOOTER //
// ./src/components/Alert/AlertList/List/index.js